import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, mergeMap, withLatestFrom, map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CheckTerms, UpdateAgreement } from '../action-creators';
import { CHECK_TERMS } from '../actions';
import AppState from '../../state';
import { getTimestamp } from '@common/utils/get-timestamp';
import { CreateDialog } from '@webapp/store/ui/action-creators';
import TermsAgreement, {
  TermsAgreementProps,
} from '@components/termsAgreement';
import store from '@webapp/store';
import { zIndices } from '@components/styles';
import { TermsToAccept } from '@webapp/store/terms/state';

export const checkTermsEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CheckTerms>(CHECK_TERMS),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.user.profile?.id),
    mergeMap(([_, state]) => {
      const {
        user: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          profile: { created_at, lastTermsAgreedDate },
        },
        terms: { terms, privacyPolicy, distributionTerms },
      } = state;
      const res: { termName: TermsToAccept; lastUpdDate: Date }[] = [];

      if (
        state.user?.profile?.created_at ||
        state.user?.profile?.lastTermsAgreedDate
      ) {
        if (
          getTimestamp(terms) > getTimestamp(lastTermsAgreedDate || created_at)
        ) {
          res.push({ termName: 'terms', lastUpdDate: terms });
        }
        if (
          getTimestamp(privacyPolicy) >
          getTimestamp(lastTermsAgreedDate || created_at)
        ) {
          res.push({ termName: 'privacyPolicy', lastUpdDate: privacyPolicy });
        }
        if (
          getTimestamp(distributionTerms) >
          getTimestamp(lastTermsAgreedDate || created_at)
        ) {
          res.push({
            termName: 'distributionTerms',
            lastUpdDate: distributionTerms,
          });
        }
      }
      return res;
    }),
    map((term) => {
      return new CreateDialog<string, TermsAgreementProps>(
        `TERMS_AGREE.${term.termName}`,
        {
          open: true,
          zIndex: zIndices.modal,
          component: TermsAgreement,
          componentProps: {
            term: term.termName,
            updateAgreement: () =>
              store.dispatch(new UpdateAgreement(term.lastUpdDate)),
          },
        }
      );
    })
  );
